export default __webpack_public_path__ + "static/style2.2_Elena-a2c02fdc7e775098d0301c02b80a0f3d.wav";